import { Application, AppSource, AppPlatform } from "@/types/application";

// Import app icons - mix of real and generated icons
import xcodeIcon from "@/assets/xcode-real-official-icon.png";
import logicProIcon from "@/assets/logic-pro-real-icon.png";
import garageBandIcon from "@/assets/garageband-official-icon.png";
import iMovieIcon from "@/assets/imovie-official-icon.png";
import safariRealIcon from "@/assets/safari-official-icon.png";
import mailRealIcon from "@/assets/mail-official-icon.png";
import photosIcon from "@/assets/photos-real-icon.png";
import keynoteIcon from "@/assets/keynote-real-icon.png";
import pagesIcon from "@/assets/pages-official-icon.png";
import numbersIcon from "@/assets/numbers-official-icon.png";
import finalCutProIcon from "@/assets/final-cut-pro-real-icon.png";

export const mockApps: Application[] = [
  {
    id: "app1",
    name: "Keynote",
    icon: keynoteIcon,
    version: "13.2",
    size: "385 MB",
    releaseDate: "2024-05-02",
    source: "appStore",
    platform: "ios",
    bundleId: "com.apple.Keynote",
    categories: ["Productivity"],
    customers: ["c1", "c3"],
    status: "published",
    description: "Keynote is the most powerful presentation app ever designed for a mobile device."
  },
  {
    id: "app2",
    name: "Pages",
    icon: pagesIcon,
    version: "13.2",
    size: "495 MB",
    releaseDate: "2024-05-02",
    source: "appStore",
    platform: "ios",
    bundleId: "com.apple.Pages",
    categories: ["Productivity"],
    customers: ["c2"],
    status: "published",
    description: "Pages is the most beautiful word processor you've ever seen on a mobile device."
  },
  {
    id: "app3",
    name: "Numbers",
    icon: numbersIcon,
    version: "13.2",
    size: "415 MB",
    releaseDate: "2024-05-02",
    source: "appStore",
    platform: "ios",
    bundleId: "com.apple.Numbers",
    categories: ["Productivity"],
    customers: ["c3", "c4"],
    status: "published",
    description: "Numbers is the most innovative spreadsheet app ever designed for a mobile device."
  },
  {
    id: "app4",
    name: "Xcode",
    icon: xcodeIcon,
    version: "15.0",
    size: "12.5 GB",
    releaseDate: "2023-12-11",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.dt.Xcode",
    categories: ["Developer Tools"],
    customers: ["c2"],
    status: "published",
    description: "Xcode includes everything developers need to create great apps for Mac, iPhone, iPad, Apple TV, and Apple Watch."
  },
  {
    id: "app5",
    name: "Final Cut Pro",
    icon: finalCutProIcon,
    version: "10.7.1",
    size: "3.2 GB",
    releaseDate: "2023-11-02",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.FinalCut",
    categories: ["Graphics & Design"],
    customers: ["c1"],
    status: "published",
    description: "Final Cut Pro is a revolutionary app for creating, editing, and producing the highest-quality video."
  },
  {
    id: "app6",
    name: "Company VPN",
    icon: "/lovable-uploads/40fc408c-1fe6-4629-be53-10996bedf8cd.png",
    version: "2.1.0",
    size: "45 MB",
    releaseDate: "2024-01-15",
    source: "custom",
    platform: "ios",
    bundleId: "com.company.vpn",
    categories: ["Utilities"],
    customers: ["c4"],
    status: "published",
    description: "Custom VPN application for secure company access."
  },
  {
    id: "app7",
    name: "Logic Pro",
    icon: logicProIcon,
    version: "10.8",
    size: "2.8 GB",
    releaseDate: "2024-01-15",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.logic10",
    categories: ["Music"],
    customers: ["c1", "c2"],
    status: "published",
    description: "Logic Pro is a complete professional recording studio on the Mac."
  },
  {
    id: "app8",
    name: "Safari",
    icon: safariRealIcon,
    version: "17.4",
    size: "150 MB",
    releaseDate: "2024-04-15",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.Safari",
    categories: ["Utilities"],
    customers: ["c1", "c2", "c3", "c4"],
    status: "published",
    description: "Safari is the best way to experience the internet on Mac."
  },
  {
    id: "app9",
    name: "Mail",
    icon: mailRealIcon,
    version: "16.0",
    size: "250 MB",
    releaseDate: "2023-09-20",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.mail",
    categories: ["Productivity"],
    customers: ["c1", "c2", "c3"],
    status: "published",
    description: "Mail is the best way to manage your email on Mac."
  },
  {
    id: "app10",
    name: "Photos",
    icon: photosIcon,
    version: "8.0",
    size: "350 MB",
    releaseDate: "2023-09-20",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.Photos",
    categories: ["Graphics & Design"],
    customers: ["c2", "c3"],
    status: "published",
    description: "Photos makes it easy to organize and edit your photos."
  },
  {
    id: "app11",
    name: "GarageBand",
    icon: garageBandIcon,
    version: "10.4.8",
    size: "1.2 GB",
    releaseDate: "2023-10-05",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.garageband10",
    categories: ["Music"],
    customers: ["c1", "c4"],
    status: "published",
    description: "GarageBand turns your Mac into a complete recording studio."
  },
  {
    id: "app12",
    name: "iMovie",
    icon: iMovieIcon,
    version: "10.3.5",
    size: "3.1 GB",
    releaseDate: "2023-10-05",
    source: "macOSCatalog",
    platform: "macos",
    bundleId: "com.apple.iMovieApp",
    categories: ["Graphics & Design"],
    customers: ["c3", "c4"],
    status: "published",
    description: "iMovie makes it easy to create beautiful movies and trailers."
  }
];

// Define macOS applications
export const macApps = [
  {
    name: "Xcode",
    version: "15.0",
    installed_date: "2023-12-11"
  },
  {
    name: "Final Cut Pro",
    version: "10.7.1",
    installed_date: "2023-11-02"
  },
  {
    name: "Logic Pro",
    version: "10.8",
    installed_date: "2024-01-15"
  },
  {
    name: "Pages",
    version: "13.2",
    installed_date: "2024-05-02"
  },
  {
    name: "Numbers",
    version: "13.2",
    installed_date: "2024-05-02"
  },
  {
    name: "Keynote",
    version: "13.2",
    installed_date: "2024-05-02"
  },
  {
    name: "Safari",
    version: "17.4",
    installed_date: "2024-04-15"
  },
  {
    name: "Mail",
    version: "16.0",
    installed_date: "2023-09-20"
  },
  {
    name: "Photos",
    version: "8.0",
    installed_date: "2023-09-20"
  },
  {
    name: "GarageBand",
    version: "10.4.8",
    installed_date: "2023-10-05"
  },
  {
    name: "iMovie",
    version: "10.3.5",
    installed_date: "2023-10-05"
  }
];

// Define Windows applications
export const windowsApps = [
  {
    name: "Microsoft Office",
    version: "365",
    installed_date: "2024-01-10"
  },
  {
    name: "Microsoft Teams",
    version: "24.05",
    installed_date: "2024-05-01"
  },
  {
    name: "Visual Studio Code",
    version: "1.78.0",
    installed_date: "2024-04-12"
  },
  {
    name: "Adobe Creative Cloud",
    version: "6.7.0.1903",
    installed_date: "2024-03-15"
  },
  {
    name: "Slack",
    version: "4.33.90",
    installed_date: "2024-04-20"
  },
  {
    name: "Google Chrome",
    version: "124.0.6367.88",
    installed_date: "2024-05-05"
  },
  {
    name: "Microsoft Edge",
    version: "124.0.2478.55",
    installed_date: "2024-05-03"
  },
  {
    name: "Zoom",
    version: "5.16.6.25642",
    installed_date: "2024-04-25"
  },
  {
    name: "Microsoft OneNote",
    version: "16.0.16227.20116",
    installed_date: "2024-03-01"
  },
  {
    name: "Notepad++",
    version: "8.5.7",
    installed_date: "2024-02-15"
  },
  {
    name: "7-Zip",
    version: "23.01",
    installed_date: "2023-10-10"
  }
];

// Define Linux applications
export const linuxApps = [
  {
    name: "Visual Studio Code",
    version: "1.78.0",
    installed_date: "2024-04-12"
  },
  {
    name: "Docker",
    version: "24.0.6",
    installed_date: "2024-03-20"
  },
  {
    name: "Node.js",
    version: "20.10.0",
    installed_date: "2024-01-05"
  },
  {
    name: "Git",
    version: "2.42.0",
    installed_date: "2023-12-10"
  },
  {
    name: "Firefox",
    version: "124.0.1",
    installed_date: "2024-05-02"
  },
  {
    name: "Chrome",
    version: "124.0.6367.88",
    installed_date: "2024-05-05"
  },
  {
    name: "LibreOffice",
    version: "7.6.4",
    installed_date: "2024-02-01"
  },
  {
    name: "Postman",
    version: "10.18.9",
    installed_date: "2024-04-10"
  },
  {
    name: "MongoDB Compass",
    version: "1.40.4",
    installed_date: "2024-03-15"
  },
  {
    name: "Slack",
    version: "4.33.90",
    installed_date: "2024-04-20"
  }
];

export const appStoreCatalog = [
  {
    id: "store1",
    name: "Slack",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/0f/59/d4/0f59d401-fedb-f909-7543-cf6f1f070d48/app_store_icons-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  },
  {
    id: "store2",
    name: "Microsoft Word",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/53/9b/96/539b9608-757f-e1ab-5901-1171b72bb1d1/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  },
  {
    id: "store3",
    name: "Microsoft Excel",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/e7/e6/4e/e7e64e11-96ac-fbe6-ba96-b0624d80e1d2/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  },
  {
    id: "store4",
    name: "Zoom",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/ec/e5/e3/ece5e3c0-8bc2-bbb5-2051-a9a29e7ca65c/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  },
  {
    id: "store5",
    name: "Adobe Photoshop",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/27/10/c1/2710c158-d3e6-c300-6eb8-32037e8f105e/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  },
  {
    id: "store6",
    name: "1Password",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/18/04/ec/1804ec65-7e1c-7cae-03c8-61ef8e97dd0e/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp",
  }
];

export const macOSCatalog = [
  {
    id: "mac1",
    name: "Logic Pro",
    icon: logicProIcon,
  },
  {
    id: "mac2",
    name: "BBEdit",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/cf/bd/c7/cfbdc7c9-8818-acf4-0e9b-085e3990b8f0/AppIcon-0-0-85-220-0-0-0-0-4-0-0-0-2x-sRGB-0-0-0-0-0.png/230x0w.webp",
  },
  {
    id: "mac3",
    name: "Affinity Designer",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/3c/b7/67/3cb767cd-7463-5782-8451-90a25b95a3cb/AppIcon-0-0-85-220-0-0-0-0-4-0-0-0-2x-sRGB-0-0-0-0-0.png/230x0w.webp",
  },
  {
    id: "mac4",
    name: "Sketch",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/99/c8/9d/99c89d95-265b-dd2c-f11b-5ee19a381c7b/AppIcon-0-0-85-220-0-0-0-0-4-0-0-0-2x-sRGB-0-0-0-0-0.png/230x0w.webp",
  }
];

// Helper function to filter apps by customer
export const getAppsByCustomer = (customerId: string): Application[] => {
  return mockApps.filter(app => app.customers.includes(customerId));
};

// Helper function to get app by ID
export const getAppById = (appId: string): Application | undefined => {
  return mockApps.find(app => app.id === appId);
};
